var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaquo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#63758D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.55.22c.233-.293.61-.293.84 0l.561.707a.89.89 0 0 1 0 1.06L2.56 5l2.392 3.013a.89.89 0 0 1 0 1.06l-.56.707c-.234.293-.61.293-.842 0L.175 5.528c-.233-.287-.233-.762 0-1.056L3.549.22ZM9.423.22c.233-.293.61-.293.841 0l.561.707a.89.89 0 0 1 0 1.06L8.433 5l2.392 3.013a.89.89 0 0 1 0 1.06l-.56.707c-.234.293-.611.293-.842 0L6.05 5.528c-.234-.287-.234-.762 0-1.056L9.423.22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaquo);
export default __webpack_public_path__ + "static/media/laquo.700a1b6a48a9eef9df552e50cb2aa62c.svg";
export { ForwardRef as ReactComponent };